import { CircularProgress, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import queryString from 'query-string';
import React, { Component, Fragment } from 'react';

import SpinnerComponent from '../../components/SpinnerComponent';
import { reportError } from '../../utils/reportApiError';
import {
  fetchWithRetry,
  isTransportError,
  isLoadBalancerStatus,
  transportErrorMessage,
  ERRORE_GENERICO,
  SERVIZIO_IN_AGGIORNAMENTO,
} from '../../utils/api/api';

/**
 * Static styles only. Anything brand-colored belongs in styleToUse below, so
 * that it is resolved against the brand theme rather than a fixed palette.
 */
const styles = {
  root: {
    height: '100%',
    padding: '4px 10px 20px 10px',
    textAlign: 'center',
  },
};
const styleToUse = (theme) => ({
  modalcontainerClass: {
    flex: 1,
    alignItems: 'center',
    alignSelf: 'center',

    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    paddingTop: '26px',
    paddingBottom: '26px',
    paddingLeft: '10px',
    paddingRight: '10px',
    marginTop: '26px',
    marginBottom: '26px',
    boxShadow:
      '0px 2px 1px -1px #00000033, 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px ' +
      theme.palette.primary.main,
    marginLeft: '20%',
    marginRight: '20%',
    height: '80%',
  },
  container: {
    border: '1px solid ' + theme.palette.primary.main,
    borderRadius: '6px',
    //margin: '4px 0px 4px 0px',
    padding: '10px',
    margin: 'auto',
    maxWidth: '780px',
  },
});
class PagamentoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      abbonamentoId: null,
      abbonamentoSospeso: null,
      abbonamentoSospesoPagamento: null,
      loading: true,
      operationInProgress: false,
      fallito: false,
      message: 'Nessuna operazione da effettuare.',
      showButtonToStartPaymentProcedure: false,
      showButtonToApprovePayment: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    const values = queryString.parse(this.props.location.search);
    if (values.id !== undefined && values.id !== null) {
      const abbonamentoId = values.id;
      this.setState({
        abbonamentoId,
      });
      this.getAbbonamentiEsercizio(abbonamentoId);
    }
  }
  handleOpen = () => {
    this.setState({ modal: true });
  };

  handleClose = () => {
    this.setState({ modal: false });
  };
  /**
   * The sentence for a subscription that failed to load, chosen from what the
   * request actually did: never arrived, was answered by the load balancer
   * instead of the pod behind it, or failed on the backend.
   */
  loadErrorMessage = (error) => {
    if (isTransportError(error)) {
      return transportErrorMessage();
    }
    if (isLoadBalancerStatus(Number(error.message))) {
      return SERVIZIO_IN_AGGIORNAMENTO;
    }
    return 'Si è verificato un errore. Caricamento dati fallito.';
  };

  getAbbonamentiEsercizio = (abbonamentoId) => {
    const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;

    const URL = ENDPOINT + '/api/abbonamenti/' + abbonamentoId;
    fetchWithRetry(URL, {
      method: 'GET',

      withCredentials: true,
      credentials: 'include',
    })
      .then((response) => {
        const status = response.status;
        if (status === 200) {
          return response.json();
        }
        // The status is what the catch below maps to a sentence: a `Response`
        // carries no `message`, so throwing that said nothing.
        throw new Error('' + status);
      })
      .then((result) => {
        if (!this.mounted) {
          return;
        }
        if (result.stato === 'SCADUTO') {
          this.setState(
            {
              fallito: true,
              loading: false,
              abbonamentoSospeso: result,
            },
            () => this.prepMessage(),
          );
        } else {
          this.setState(
            {
              loading: false,
              abbonamentoSospeso: result,
            },
            () => this.prepMessage(),
          );
        }
      })
      .catch((error) => {
        if (!this.mounted) {
          return;
        }
        this.setState({
          loading: false,
        });
        reportError(this.loadErrorMessage(error));
      });
  };
  getAbbonamentiEsercizioRepeat = (abbonamentoId) => {
    const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;
    const URL = ENDPOINT + '/api/abbonamenti/' + abbonamentoId;
    fetchWithRetry(URL, {
      method: 'GET',
    })
      .then((response) => {
        const status = response.status;
        if (status === 200) {
          return response.json();
        }
        throw new Error('' + status);
      })
      .then((result) => {
        if (!this.mounted) {
          return;
        }
        this.setState(
          {
            loading: false,
            abbonamentoSospeso: result,
          },
          () => this.prepMessage(),
        );
      })
      .catch((error) => {
        if (!this.mounted) {
          return;
        }
        this.setState({
          loading: false,
        });
        reportError(this.loadErrorMessage(error));
      });
  };
  onAvviaProceduraPagamento = () => {
    this.setState({
      operationInProgress: true,
    });
    this.startPaymentProcedure(this.state.abbonamentoSospeso.id);
  };

  startPaymentProcedure = (abbonamentoId) => {
    const requestBody = {
      abbonamentoId: abbonamentoId,
    };
    const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;
    const URL = ENDPOINT + '/api/abbonamenti/pagamenti';
    fetchWithRetry(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        const status = response.status;
        if (status === 201) {
          return response.json();
        }
        throw new Error('' + status);
      })
      .then((result) => {
        if (!this.mounted) {
          return;
        }
        if (result.stato === 'INSERITO') {
          this.setState(
            {
              operationInProgress: false,
            },
            () => {
              this.getAbbonamentiEsercizioRepeat(abbonamentoId);
              this.prepMessage();
            },
          );
        } else if (result.stato === 'CREATO') {
          this.setState(
            {
              abbonamentoSospesoPagamento: result,
              operationInProgress: false,
            },
            () => this.prepMessage(),
          );
        }
      })
      .catch((error) => {
        if (!this.mounted) {
          return;
        }
        let msg = ERRORE_GENERICO;
        let title = null;
        if (error.message === '400') {
          msg =
            'Creazione nuovo pagamento non permessa: esiste già un pagamento in corso o completato.';
        } else if (isTransportError(error)) {
          msg = transportErrorMessage();
        } else if (isLoadBalancerStatus(Number(error.message))) {
          msg = SERVIZIO_IN_AGGIORNAMENTO;
        }
        this.setState({
          loading: false,
          operationInProgress: false,
        });
        reportError(msg, title);
      });
  };

  openApproveLink = (event) => {
    event.preventDefault();
    if (this.state.abbonamentoSospesoPagamento !== null) {
      window.location.href =
        this.state.abbonamentoSospesoPagamento.paypalApproveLink;
    } else {
      window.location.href =
        this.state.abbonamentoSospeso.pagamento.paypalApproveLink;
    }
  };
  componentWillUnmount() {
    // The retry keeps a request alive for seconds after the operator may have
    // left the page, so what comes back is dropped rather than set on state.
    this.mounted = false;
    clearTimeout(this.intervalID);
  }

  prepMessage = () => {
    let message = this.state.message;
    if (this.state.abbonamentoSospesoPagamento !== null) {
      message =
        "Clicca sul pulsante per completare il pagamento dell'abbonamento" +
        ' al servizio ' +
        this.props.theme.nomeBrand +
        ' ' +
        (this.state.abbonamentoSospeso.nomeEsercizio !== null
          ? "per l'esercizio commerciale " +
            this.state.abbonamentoSospeso.nomeEsercizio
          : '') +
        '.';
      this.setState({
        showButtonToApprovePayment: true,
        showButtonToStartPaymentProcedure: false,

        message: message,
      });
    } else {
      if (this.state.abbonamentoSospeso !== null) {
        if (
          this.state.abbonamentoSospeso.pagamento === null &&
          this.state.abbonamentoSospeso.error === false
        ) {
          message =
            "Avvia la procedura di pagamento dell'abbonamento" +
            ' al servizio ' +
            this.props.theme.nomeBrand +
            ' ' +
            (this.state.abbonamentoSospeso.nomeEsercizio !== null
              ? " per l'esercizio commerciale " +
                this.state.abbonamentoSospeso.nomeEsercizio
              : '') +
            ' cliccando sul pulsante qui sotto. ';

          this.setState({
            showButtonToStartPaymentProcedure: true,
            showButtonToApprovePayment: false,

            message: message,
          });
        } else if (
          this.state.abbonamentoSospeso.pagamento === null &&
          this.state.abbonamentoSospeso.error === true
        ) {
          message =
            "Tentativo di avvio pagamento fallito. Avviare nuovamente la procedura di pagamento dell'abbonamento" +
            ' al servizio ' +
            this.props.theme.nomeBrand +
            ' ' +
            (this.state.abbonamentoSospeso.nomeEsercizio !== null
              ? "per l'esercizio commerciale " +
                this.state.abbonamentoSospeso.nomeEsercizio
              : '') +
            ' cliccando sul pulsante qui sotto. ';

          this.setState({
            showButtonToStartPaymentProcedure: true,
            showButtonToApprovePayment: false,

            message: message,
          });
        } else {
          if (this.state.abbonamentoSospeso.pagamento.stato === 'CREATO') {
            message =
              "Clicca sul pulsante per completare il pagamento dell'abbonamento" +
              ' al servizio ' +
              this.props.theme.nomeBrand +
              ' ' +
              (this.state.abbonamentoSospeso.nomeEsercizio !== null
                ? "per l'esercizio commerciale " +
                  this.state.abbonamentoSospeso.nomeEsercizio
                : '') +
              '.';
            this.setState({
              showButtonToApprovePayment: true,
              showButtonToStartPaymentProcedure: false,

              message: message,
            });
          } else if (
            this.state.abbonamentoSospeso.pagamento.stato === 'INSERITO'
          ) {
            message =
              "Il link del pagamento per l' abbonamento " +
              (this.state.abbonamentoSospeso.nomeEsercizio !== null
                ? "per l'esercizio commerciale " +
                  this.state.abbonamentoSospeso.nomeEsercizio
                : '') +
              ' è in elaborazione.';
            this.setState({
              message: message,
              showButtonToStartPaymentProcedure: false,
              showButtonToApprovePayment: false,
            });
            setTimeout(
              () =>
                this.getAbbonamentiEsercizioRepeat(this.state.abbonamentoId),
              6000,
            );
          } else if (
            this.state.abbonamentoSospeso.pagamento.stato === 'APPROVATO' ||
            this.state.abbonamentoSospeso.pagamento.stato === 'PENDENTE'
          ) {
            message =
              "Il pagamento dell'abbonamento " +
              (this.state.abbonamentoSospeso.nomeEsercizio !== null
                ? "per l'esercizio commerciale " +
                  this.state.abbonamentoSospeso.nomeEsercizio
                : '') +
              ' è in elaborazione.';
            this.setState({
              message: message,
              showButtonToStartPaymentProcedure: false,
              showButtonToApprovePayment: false,
            });
          } else if (
            this.state.abbonamentoSospeso.pagamento.stato === 'FALLITO' ||
            this.state.abbonamentoSospeso.pagamento.stato === 'NEGATO'
          ) {
            message =
              "Il pagamento dell'abbonamento " +
              (this.state.abbonamentoSospeso.nomeEsercizio !== null
                ? "per l'esercizio commerciale " +
                  this.state.abbonamentoSospeso.nomeEsercizio
                : '') +
              ' è fallito.';
            this.setState({
              message: message,
              showButtonToStartPaymentProcedure: false,
              showButtonToApprovePayment: false,
            });
          } else if (
            this.state.abbonamentoSospeso.pagamento.stato === 'COMPLETATO'
          ) {
            message =
              "Il pagamento dell'abbonamento " +
              (this.state.abbonamentoSospeso.nomeEsercizio !== null
                ? "per l'esercizio commerciale " +
                  this.state.abbonamentoSospeso.nomeEsercizio
                : '') +
              ' è stato completato con successo.';
            this.setState({
              message: message,
              showButtonToStartPaymentProcedure: false,
              showButtonToApprovePayment: false,
            });
          }
        }
      }
      if (this.state.operationInProgress) {
        message =
          'Elaborazione in corso del pagamento del canone annuale per ' +
          (this.state.abbonamentoSospeso.nomeEsercizio !== null
            ? "per l'esercizio commerciale " +
              this.state.abbonamentoSospeso.nomeEsercizio
            : '') +
          this.state.abbonamentoSospeso.nomeEsercizio +
          '.';
        this.setState({
          message: message,
        });
      }
    }
  };
  render() {
    const { classes } = this.props;

    let showButtonToStartPaymentProcedure =
      this.state.showButtonToStartPaymentProcedure;
    let showButtonToApprovePayment = this.state.showButtonToApprovePayment;

    return (
      <Fragment>
        <CssBaseline />
        <Container style={styles.root}>
          {this.state.loading ? (
            <SpinnerComponent size={32} />
          ) : (
            <Fragment>
              <Typography
                component="div"
                style={{ minHeight: '272px', padding: '4px 0px 4px 0px' }}
              >
                <img
                  src={this.props.theme.logo.url}
                  alt="logo"
                  style={{ width: '270px' }}
                />
              </Typography>
              <Container className={classes.container}>
                {!showButtonToApprovePayment &&
                this.state.operationInProgress ? (
                  <CircularProgress />
                ) : null}
                <Typography component="div">
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: 'left',
                      padding: '10px',
                      color: 'black',
                    }}
                  >
                    {this.state.message}
                  </Typography>
                </Typography>
                {showButtonToStartPaymentProcedure &&
                !this.state.operationInProgress &&
                this.state.fallito !== true ? (
                  <Button
                    type="button"
                    onClick={this.onAvviaProceduraPagamento}
                    variant="contained"
                    size="medium"
                    style={{
                      color: this.props.theme.palette.text.main,
                      margin: '10px',
                      backgroundColor: this.props.theme.palette.primary.main,
                    }}
                  >
                    AVVIA PROCEDURA PAGAMENTO
                  </Button>
                ) : null}
                {showButtonToApprovePayment &&
                !this.state.operationInProgress &&
                this.state.fallito !== true ? (
                  <Button
                    type="button"
                    onClick={this.openApproveLink}
                    variant="contained"
                    size="medium"
                    style={{
                      color: this.props.theme.palette.text.main,
                      margin: '10px',
                      backgroundColor: this.props.theme.palette.primary.main,
                    }}
                  >
                    VAI ALLA PAGINA DEL PAGAMENTO
                  </Button>
                ) : null}
              </Container>
            </Fragment>
          )}
        </Container>
      </Fragment>
    );
  }
}
export default withStyles(styleToUse, { withTheme: true })(PagamentoPage);
